import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-active-accounting-v2",
  "use": "icon-active-accounting-v2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-active-accounting-v2\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><g transform=\"translate(3 3.5)\"><path d=\"m0 3 .007.117a1 1 0 0 0 .876.876L1 4h15a2 2 0 0 1 2 2v1.5h-3a3 3 0 0 0-.176 5.995L15 13.5h3V15a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3Zm17 6.5a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2h2Z\" fill=\"#8DCB29\" /><rect fill=\"#218907\" width=\"12\" height=\"2\" rx=\"1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol